export const DEFAULT_COLUMNS: string[] = ['timestamp', 'responseCode', 'resourceAggregateType', 'request', 'response'];
export const ALL_COLUMNS: string[] = ['timestamp', 'responseCode', 'resourceAggregateType', 'request', 'response'];

export enum LogMessageTypeEnum {
  DmsInbound = 'DmsInbound',
  DmsOutbound = 'DmsOutbound',
}

export interface LogMessageDto {
  aggregateId: string;
  aggregateType: string;
  resourceAggregateType: string;
  type: LogMessageTypeEnum;
  timestamp: Date;
  request: LogMessageContent | null;
  response: LogMessageContent | null;
  userId: string;
  responseCode: number;
}

export class LogMessageSto {
  aggregateId: string;
  aggregateType: string;
  resourceAggregateType: string;
  type: LogMessageTypeEnum;
  timestamp: Date;
  request: LogMessageContent | null;
  response: LogMessageContent | null;
  userId: string;
  responseCode: number;

  constructor(dto: LogMessageDto) {
    this.aggregateId = dto?.aggregateId;
    this.aggregateType = dto?.aggregateType;
    this.resourceAggregateType = dto?.resourceAggregateType;
    this.type = dto?.type;
    this.timestamp = dto?.timestamp;
    this.request = dto?.request;
    this.response = dto?.response;
    this.userId = dto?.userId;
    this.responseCode = dto?.responseCode;
  }
}

export class LogMessageContent {
  type: string;
  preview: string;
  content: string;
}

export class LogMessageTableRow {
  // Columns
  rowId: string;
  timestamp: Date;
  responseCode: number;
  resourceAggregateType: string;
  request: LogMessageContent | null;
  response: LogMessageContent | null;

  // administrative
  logMessageObject: LogMessageSto;

  constructor(sto: LogMessageSto) {
    this.rowId = sto?.aggregateId;
    this.timestamp = sto?.timestamp;
    this.resourceAggregateType = sto?.resourceAggregateType;
    this.responseCode = sto?.responseCode;
    this.request = sto?.request;
    this.response = sto?.response;
    this.logMessageObject = sto;
  }
}
